  // Get the text field
  if (document.querySelector('.promo-blue-wrapper .promo-text p strong:nth-of-type(2)')) {
    const text = document.querySelector('.promo-blue-wrapper .promo-text p strong:nth-of-type(2)');
    text.addEventListener('click', function () {
      // Get the text content from the element
      let copyText = text.textContent;
      // Copy the text inside the text field
      navigator.clipboard
        .writeText(copyText)
        .then(function () {})
        .catch(function (err) {
          console.error('Unable to copy text: ', err);
        });
    });
  }